
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { App, URLOpenListenerEvent } from '@capacitor/app';


const AppUrlListener: React.FC<any> = () => {
    let history = useHistory();
    useEffect(() => {
        App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
            // split the incoming URL
            const slug = event.url.split('?').pop();
            if (slug) {
                // check the slug
                if (slug.substring(0, 5) == "login")
                    history.push("/login");
                else if (slug.substring(0, 3) == "app")
                    history.push("/main");
                else if (slug.substring(0, 2) == "cc")
                    history.push("/content/" + slug.substring(2) + "/url");
                else if (slug.substring(0, 2) == "ur")
                    history.push("/user/" + slug.substring(2));
                else if (slug.substring(0, 2) == "gg")
                    history.push("/gamepage/" + slug.substring(2));
                else if (slug.substring(0, 2) == "gp")
                    history.push("/gamepost/" + slug.substring(2));
                else
                    history.push("/" + slug);

                window.location.reload();
            }
        });
    }, []);

    return null;
};

export default AppUrlListener;